const adminInitializeBlock = ( initializeCallback, blockSelector ) => {
	return ( element ) => {
		const $blockContainer = element.find( blockSelector );

		initializeCallback( $blockContainer, true );

		const buttons = $blockContainer.find( 'button' );
		const inputsButton = $blockContainer.find( 'input[type="button"]' );
		const links = $blockContainer.find( 'a' );
		const $blockBody = $blockContainer.closest( 'body.block-editor-iframe__body' );

		buttons.off( 'click' ).off( 'blur' ).off( 'mouseout' ).off( 'mousemove' ).off( 'mouseleave' ).off( 'mouseenter' ).off( 'mouseover' );
		inputsButton.off( 'click' ).off( 'blur' ).off( 'mouseout' ).off( 'mousemove' ).off( 'mouseleave' ).off( 'mouseenter' ).off( 'mouseover' );
		links.off( 'click' ).off( 'blur' ).off( 'mouseout' ).off( 'mousemove' ).off( 'mouseleave' ).off( 'mouseenter' ).off( 'mouseover' );		
		$blockBody.addClass( themeVars.site_editor_class );
	};
};

export default adminInitializeBlock;